type AppHasCrashedState = Readonly<{
  isCrashed: true;
  technicalErrorMessage: string;
  isAutomaticEmailSent?: boolean;
  cause?: Record<string, unknown>;
}>;

type AppHasNotCrashedState = Readonly<{
  isCrashed: false;
  isAutomaticEmailSent: false;
}>;

export type AppCrashState = AppHasCrashedState | AppHasNotCrashedState;

export const appCrashInitialState: AppCrashState = {
  isAutomaticEmailSent: false,
  isCrashed: false,
};
